module.exports = __webpack_public_path__ + "static/img/Inspection23.38614dcc.jpg";